import invoice from "./invoice.component";
import invoiceUrls from "./invoice.urls";
import InvoiceTransforms from "./invoice.transforms";

const invoiceModule = angular
  .module("app.components.invoice", [])
  .component("invoicePage", invoice)
  .service("InvoiceTransforms", InvoiceTransforms)
  .config(invoiceUrls);

export default invoiceModule;



// WEBPACK FOOTER //
// ./src/pages/invoice/invoice.module.js